// TODO: improve order structure and standarize naming
export enum Access {
  // test
  _Test_True,
  _Test_False,
  _Test_Random,

  // fixed
  Allow,
  Deny,

  // components
  OrganizationsFilter,
  DevicesOperationalStateFilter,
  ViewSourceInfo,
  AlertsConfiguration_TableRowAdminView,
  AlertsConfiguration_SmsNotifications,

  // modals
  DeviceAlertsConfigurationModal,
  SaveUserModal,
  SimulateUserModal,
  DeleteUserModal,
  CreateTemporalUserModal,
  UpdateDeviceCollectionRelationModal,
  UpdateAccountCollectionRelationModal,
  SaveHardwareConfigurationModal,
  SetTicketModal,
  UpdateAliasModal,
  DeviceProfileModal,
  UpdateDeviceAliasOtherOrganizations,

  // DGA
  CreateDGAConfigurationModal,
  UpdateDGAConfigurationsModal,
  UpdateDGAGeneralConfiguration,
  UpdateDGASubmissionsConfiguration,
  RetryDGASubmissions,
  RetryMassiveDGASubmissions,
  UpdateDGAMaxFlow,
  UpdateDGANotificationsConfiguration,
  DeleteDGAConfiguration,

  // buttons
  UsersTable_OptionsMenu,
  UserOptionsMenu_SimulateUserButton,
  UserOptionsMenu_DeleteUserButton,
  UpdateRatingCurve,

  // actions
  UpdateDeviceUserAccess,
  CreateDeviceUserAccess,
  DeleteDeviceUserAccess,
  CreateDevice,
  CreateCollection,
  DeleteCollection,
  CreateSMAConfiguration,
  ViewDeletedDevices,
  ViewDeletedUsers,
  UpdateDeviceStatus,
  ViewDeviceMetricsPriorityList,

  // Device configuration
  /**
   * Access to enter to device configuration modal,
   * the access is enabled if any of the following is true:
   * - Has access to DeviceConfiguration_GeneralTab
   * - Has access to DeviceConfiguration_StateTab
   * - Has access to CloneDevice
   * - Has access to DeleteDevice
   */
  DeviceConfigurationModal,
  /**
   * Access to enter to general tab from device configuration modal,
   * the access is enabled if any of the following is true:
   * - Has access to UpdateDeviceBasicConfiguration
   * - Has access to UpdateDeviceAlias
   */
  DeviceConfiguration_GeneralTab,
  /**
   * Access to enter Gate tab from device configuration modal,
   * the access is enabled if any of the following is true:
   * - Has access to UpdateGatePositionLimits
   * - Has access to CreateGateLinkedDevices
   * - Has access to UpdateGateOpeningAlarmNotifications
   */
  DeviceConfiguration_GateTab,
  UpdateGatePositionLimits,
  CreateGateLinkedDevices,
  UpdateGateOpeningAlarmNotifications,
  /**
   * Access to enter to state tab from device configuration modal,
   * the access is enabled if any of the following is true:
   * - Has access to UpdateDeviceOperationalState
   */
  DeviceConfiguration_StateTab,
  CloneDevice,
  DeleteDevice,
  /**
   * Access to update the following attributes from device:
   * - name
   * - type
   * - organization
   * - icn
   * - location
   */
  UpdateDeviceBasicConfiguration,
  UpdateDeviceAlias,
  UpdateDevice_DeviceUserAccess,

  /**
   * Access to enter to alerts configuration modal for a device,
   * the access is enabled if any of the following is true:
   * - Has access to UpdateDeviceAlertNotificationsConfiguration
   * - Has access to UpdateDeviceAlertsConfiguration
   * - Has access to UpdateDeviceAlertsBasicConfiguration
   * - Has access to DisableDeviceAlertsConfiguration
   */
  DeviceAlertsModal,
  UpdateDeviceAlertNotificationsConfiguration,
  UpdateDeviceAlertsConfiguration,
  UpdateDeviceAlertsBasicConfiguration,
  DisableDeviceAlertsConfiguration,
  ShowRawDeviceAlertsData,
  /**
   * Access to update device operational state,
   * the access if enabled if any of the specific
   * update operationalState action access is enabled
   */
  UpdateDeviceOperationalState,
  UpdateDeviceOperationalState_DevelopmentToInitialization,
  UpdateDeviceOperationalState_DevelopmentToOutOfService,
  UpdateDeviceOperationalState_InitializationToActive,
  UpdateDeviceOperationalState_InitializationToOutOfService,
  UpdateDeviceOperationalState_ActiveToMaintenance,
  UpdateDeviceOperationalState_ActiveToOutOfService,
  UpdateDeviceOperationalState_MaintenanceToActive,
  UpdateDeviceOperationalState_MaintenanceToOutOfService,
  UpdateDeviceOperationalState_OutOfServiceToActive,

  // Device data configuration
  DeviceDataConfigurationModal,
  DeviceDataConfiguration_CalibrationTab,
  DeviceDataConfiguration_FlowLimitTab,
  DeviceDataConfiguration_FiltersTab,
  DeviceDataConfiguration_RatingCurvesTab,
  DeviceDataConfiguration_MathModelingTab,
  DeviceDataConfiguration_RadarTab,

  // User configuration
  /**
   * Access to enter to user configuration modal,
   * the access is enabled if any of the following is true:
   * - Has access to UpdateUser_DeviceUserAccess
   */
  UserConfigurationModal,
  UpdateUser_DeviceUserAccess,

  /**
   * Access to enter to device access modal (AMARU-609),
   * the access is enabled if any of the following is true:
   * - Has access to UpdateDevice_DeviceUserAccess
   */
  DeviceAccessModal,

  MetricsViews_ViewConfiguration,

  ShowAuditAdminUsers,
  UpdateOrganizationPreferences,
  UpdateOtherOrganizationPreferences,
  UpdateOtherUsersPreferences,
  ViewActivityLogs,

  ViewGateMovementsHistory,
  /** Mover la compuerta y detener la operación */
  OperateGate,
  UpdateMultipleDevicesTagsModal,
  ResendUserCredentials,
  HardDeleteUser,
  HardDeleteOrganization,

  /**
   * Access to global keyboard shortcuts (AmaruGod only).
   */
  GlobalShortcuts,
}
